import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import style1 from './assets/images/style1.png';
import style2 from './assets/images/style2.png';
import style3 from './assets/images/style3.png';
import style4 from './assets/images/style4.png';


const ReactLesson11 = () => {
  const [language, changeLanguage] = useState("react");
  const [lineNumbers, toggleLineNumbers] = useState(false);
    const code = (
      'text',
      `
      import React from 'react';

      const App = () => {

        const myStyle = {
          color: 'red',
          fontSize: '23px',
         //other CSS properties
    
        };

        return (
          <div style={myStyle}>
          <p>This is a Styled Component!</p>
          </div>
        );

      }

      export default App;

      `
    );

    const code1 = (
      'text',
      `
      import React from 'react';

      const App = () => {

        return {
          <div style={{color: 'red', fontSize: '23'}}>
          <p>This is a styled component</p>
          </div>
        };
      }

      export default App;
      
      `
    );
    const code2 = (
      'text',
      `
         .myComponent {
          color: red;
          font-size: 23px;
         }
      
      `
    );
    const code3 = (
      'text',
      `
      import React from 'react';
      import './App.css';

      const App = () => (
        return {
          <div className="myComponent">
          <p>This is Styled component using CSS!</p>
          </div>
        };
      );

     

      export default App;
      
      `
    );



  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">
    <h3><strong>Styling Components</strong></h3>
      <p>Styling in React, much like in any web development, holds significant importance for reasons such as aesthetics, responsive design, readability and clarity, branding and consistency, etc.</p>
      <p>Styling React components can be done using various methods. We shall look at some popular approaches:</p>
      <ol class="list-group list-group-numbered mb-4">
           <li class="list-group-item"><strong>Inline Styling:</strong>
           <ol>
               <li>Apply styles directly to JSX elements using the <strong>style attribute</strong>.</li>
               <li>Use JavaScript objects to define styles.</li>
               <CopyBlock
                        language={"react"}
                        text={code} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />               <p>We can also write directly in our JSX as follows:</p>
<CopyBlock
                        language={"react"}
                        text={code1} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />               <p>Now notice in traditional CSS styling, we would do smething like this:</p>
               <pre><strong>font-size: 23px</strong></pre>
               <p>In React we do:</p>
               <pre><strong>fontSize: 23</strong></pre>
               <p><strong>OR</strong></p>
               <pre><strong>fontSize: '23px'</strong></pre>
               <p>Same goes for <strong>textTransform, zIndex, etc</strong> </p>
           </ol>
           </li>
           <li class="list-group-item"><strong>CSS Stylesheets:</strong>
           
           <ol>
               <li>Create separate CSS files and import them into your components.</li>
               <li>Apply class names to your JSX elements.</li>
               <CopyBlock
                        language={"react"}
                        text={code2} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />      

                       <CopyBlock
                        language={"react"}
                        text={code3} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />             
            </ol>
            </li>
      </ol>
      <p>We shall look at styling with Bootstrap in a separate lesson.</p>
      <h3><strong>Summary</strong></h3>
      <p>Styling in React is crucial for creating visually appealing, user-friendly, and maintainable applications. It contributes significantly to the overall user experience, brand representation, development efficiency, and long-term maintainability of the project.</p>
 
    
   </div>
      </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default ReactLesson11;
  